import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { UserModel } from '../../models/auth/user.model';
import { Router } from '@angular/router';
import { NuevoUsuario } from '../../models/auth/nuevo-usuario.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private baseUrl = environment.urlApiAuth;

  private _usuario!: UserModel;
  private authSessionStorageData = 'olvrdt2022';
  public showLoader: boolean = false;

  get usuario(): UserModel {
    this._usuario = this.getAuthFromSessionStorage();
    return { ...this._usuario };
  }

  set usuario(user: UserModel) {}

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  // SC INTEGRA-130 funcion define observable para iniciar sesion.
  login(email: string, pass: string) {
    const url = `${this.baseUrl}/login.php`;
    // console.log(url);
    const body = { email: email, password: pass };
   
    return this.http.post<UserModel>(url, body).pipe(
      map((resp) => {
        if (resp.id) {
          //this.showLoader = true;
          return resp;
        }else{
          return resp.message;
        }
      }),
      catchError((err) => {
        return of(err);
      })
    );
  }


  //SC INTEGRA-130 funcion cierra sesion eliminando los datos usuario del sesion storage.
  logout() {
    localStorage.removeItem(this.authSessionStorageData);
    this.router.navigate(['/auth/login'], {
      queryParams: {},
    });
  }

  // registerNuevoUsuario(nuevoUsuario: NuevoUsuario) {
  //   const url = `${this.baseUrl}/Cliente`;
  //   const body = { ...nuevoUsuario };
  //   return this.http.post<any>(url, body).pipe(
  //     map((resp) => {
  //       const respuesta = {
  //         id_cliente: resp.cliente.id_cliente,
  //         codigo_cliente: resp.cliente.codigo,
  //         nombre_cliente: resp.cliente.nombre,
  //         email: resp.usuario_web.email,
  //         usuario_web: resp.usuario_web.usuario,
  //       };
  //       return respuesta;
  //     }),
  //     catchError((err) => of(err.error))
  //   );
  // }

  //SC INTEGRA-130 se setean los valores de sesion del usuario logeado.
  public setAuthFromSessionStorage(auth: any): boolean {
    // store auth authToken/refreshToken/epiresIn in local storage to keep user logged in between page refreshes
    console.log(auth.token);
    if (auth && auth.token) {
      this._usuario = auth;
      sessionStorage.setItem(this.authSessionStorageData, JSON.stringify(auth));
      return true;
    }
    return false;
  }

  //SC INTEGRA-130se obtienen los valores de sission del cliente.
  private getAuthFromSessionStorage(): UserModel {
    try {
      const data = sessionStorage.getItem(this.authSessionStorageData);
      const authData: UserModel = JSON.parse(data!);
      return authData;
    } catch (error) {
      return undefined!;
    }
  }

  // MV CATWEB-347 Renueva el tiempo de caducidad del token
  // public refreshToken() {
  //   let data: UserModel = this.getAuthFromSessionStorage();
  //   data.expire =
  //     Date.now() + this.configService.config.sesion.session_times * 1000;
  //   this.setAuthFromSessionStorage(data);
  // }

}
